import React,{useState, useEffect}  from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Cppsidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Carray(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
         <Sides/>
       <Helmet>
     <meta charset="utf-8" />
     <title>Master C++ Arrays with CodeExampler's Tutorial for Beginners</title>
     <meta name="description" content="Get ahead with CodeExampler's easy-to-follow C++ array tutorial for beginners. Learn about one-dimensional and multi-dimensional arrays, dynamic arrays, and more. Free online tutorials available."/>
<meta name="keywords" content="C++ arrays, dynamic arrays, multi-dimensional arrays, programming language tutorial,cpp array, arraylist, C++ beginners,,sort array in cpp, learn programming, free tutorials"/>
<link rel="canonical" href="https://www.codeexampler.com/cpp-array" />




 </Helmet>

 <div className='lg:pl-56'>

    <h1 className="m-4 mh1">Array statement in c++</h1>

    <div className="first">
        <a href="/cpp-continue">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/cpp-function">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <p className="mt-4 para">1, This is a collection of similar types of data and stored manually consecutively under one name<br/>
2, The index number will be different<br/>
3, The Main purpose of the array used to handle a large volume of data of some type more easily
</p>


<h2 className='headings'>There are two types of array in C++:</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">{"\n"}
            <span className="qwerty-11">1,</span>
            <span className="qwerty-10">  One-dimensional array in c++</span>
            {"\n"}
            <span className="qwerty">2,</span>
            <span className="qwerty-4"> Multi-dimensional array in c++</span>
              {"\n"} {"\n"}
          </code>
        </pre> 
      </div>



<h2 className='headings'>This is Basic array c++ style:</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">{"\n"}
            <span className="qwerty-10">Ex-</span>
            <span className="qwerty-3"> &#123;</span>
            <span className="qwerty-11">10,20,30,40,50</span>
            <span className="qwerty-3">&#125;</span>
              {"\n"} {"\n"}
          </code>
        </pre>
      </div>



<h2 className='headings'>array in c++ syntax:</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code >{"\n"}
            <span className="qwerty">Type array_name </span>
            <span className="qwerty-3">[</span>
            <span className="qwerty-5">size</span>
            <span className="qwerty-3">];</span>
            {"\n"}
            <span className="qwerty-10">Ex-int a </span>
            <span className="qwerty-3">[</span>
            <span className="qwerty-5">4</span>
            <span className="qwerty-3">]</span>
            {"\n"}
            <span className="qwerty-11">int b </span>
            <span className="qwerty-3">[</span>
            <span className="qwerty-5">5</span>
            <span className="qwerty-3">]</span>
              {"\n"} {"\n"}
          </code>
        </pre>
      </div>




<h2 className='headings'>C++ Initialize Array:</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code >{"\n"}
            <span className="qwerty">int a </span>
            <span className="qwerty-3">[</span>
            <span className="qwerty-11">6</span>
            <span className="qwerty-3">]</span>
            <span className="qwerty-3">= &#123;</span>
            <span className="qwerty-5">20,40,30,60,50</span>
            <span className="qwerty-3">&#125;</span>
            {"\n"}
            <span className="qwerty-10">int a </span>
            <span className="qwerty-3">[]</span>
            <span className="qwerty-3">= &#123;</span>
            <span className="qwerty-5">1,2,3,5,8,10</span>
            <span className="qwerty-3">&#125;</span>
            {"\n"}
            <span className="qwerty-11">float a </span>
            <span className="qwerty-3">[]</span>
            <span className="qwerty-3">= &#123;</span>
            <span className="qwerty-5">2.8,20.46,8.6,4.5,46.50</span>
            <span className="qwerty-3">&#125;</span>
              {"\n"} {"\n"} 
           
           
          </code>
        </pre>
      </div>




<h2 className='headings'>Q-Write a Program to print an Array in C++?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">{"\n"}
            <span className="qwerty-7">#include </span>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-5">iostream</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}
            <span className="qwerty-2">using </span>
            <span className="qwerty-5">namespace </span>
            <span className="qwerty-2">std; </span>
            {"\n"}
            <span className="qwerty-11">int </span>
            <span className="qwerty-10">main</span>
            <span className="qwerty-3"> ()</span>
            {"\n"}
            <span className="qwerty-3"> &#123; </span>
            {"\n"} {"\n"}
            <span className="qwerty-11"> int  </span>
            <span className="qwerty-10">i </span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-11"> int </span>
            <span className="qwerty-10">a </span>
            <span className="qwerty-3"> [] = &#123; </span>
              <span className="qwerty-11">1,2,3,4,5,6</span>
              <span className="qwerty-3">&#125; ; </span>
            {"\n"}
            <span className="qwerty-3"> for </span>
            <span className="qwerty-3">(</span>
            <span className="qwerty-10">i</span>
            <span className="qwerty-3"> = </span>
            <span className="qwerty-5">0</span>
            <span className="qwerty-3">; </span>
            <span className="qwerty-10">i </span>
            <span className="qwerty-3">&#60; </span>
            <span className="qwerty-5">5</span>
            <span className="qwerty-3">; </span>
            <span className="qwerty-10">i </span>
            <span className="qwerty-3">++)</span>
            {"\n"}
            <span className="qwerty-3">  &#123; </span>
            {"\n"}
            <span className="qwerty-5">  cout </span>
            <span className="qwerty-3">&#60;&#60;</span>
            <span className="qwerty-10"> a </span>
            <span className="qwerty-3">[</span>
            <span className="qwerty-10"> i </span>
            <span className="qwerty-3">] &#60;&#60; "</span>
            <span className="qwerty-10">\n</span>
            <span className="qwerty-3">" ;</span>
            {"\n"}
            <span className="qwerty-3">  &#125; </span>
            {"\n"}
            <span className="qwerty-11">  return </span>
            <span className="qwerty-10">0 </span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-3"> &#125; </span>
            {"\n"} {"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code className="python hljs">
            {"\n"} 
             
              <span className="qwerty-4">2 </span>
              {"\n"} 
              <span className="qwerty-10">3 </span>
              {"\n"} 
              <span className="qwerty-4">4 </span>
              {"\n"} 
              <span className="qwerty-10">5 </span>
              {"\n"}</code>{"\n"}</pre>
        </div>
      </div>






<h2 className='headings'>Q- Write a program to input an array of 10 elements and print only even elements?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code >{"\n"}
            <span className="qwerty-11">#include </span>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-5">iostream</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}
            <span className="qwerty">using </span>
            <span className="qwerty-5">namespace </span>
            <span className="qwerty">std</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-11">int </span>
            <span className="qwerty-10">main</span>
            <span className="qwerty-3"> ()</span>
            {"\n"}
            <span className="qwerty-3"> &#123; </span>
            {"\n"} {"\n"}
            <span className="qwerty-11"> for </span>
            <span className="qwerty-3">( </span>
            <span className="qwerty-10">i </span>
              <span className="qwerty-3">= </span>
              <span className="qwerty">0</span>
              <span className="qwerty-3">; </span>
            <span className="qwerty-10">i </span>
            <span className="qwerty-5">&#60;</span>
            <span className="qwerty">10</span>
            <span className="qwerty-3">; </span>
            <span className="qwerty-10">i</span>
            <span className="qwerty-3">++)</span>
            {"\n"}
            <span className="qwerty-3"> &#123; </span>
            {"\n"}
            <span className="qwerty-11"> if </span>
            <span className="qwerty-3">( </span>
            <span className="qwerty">a </span>
              <span className="qwerty-3">[</span>
              <span className="qwerty-10">i</span>
              <span className="qwerty-3">] </span>
            <span className="qwerty-3">&#60; </span>
            <span className="qwerty-5">maximum </span>
            <span className="qwerty-3">)</span>
            {"\n"}
            <span className="qwerty-5"> maximum </span>
            <span className="qwerty-3">= </span>
            <span className="qwerty">a </span>
            <span className="qwerty-3">[</span>
            <span className="qwerty-10">i</span>
            <span className="qwerty-3">] </span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-3"> &#125; </span>
            {"\n"}
            <span className="qwerty-5">  cout </span>
            <span className="qwerty-3">&#60;&#60; "</span>
            <span className="qwerty-11">maximum </span>
            <span className="qwerty-3">= "&#60;&#60;</span>
            <span className="qwerty-11"> maximum </span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-11">  return </span>
            <span className="qwerty">0 </span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-3"> &#125; </span>
            {"\n"} {"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code >
            {"\n"} 
              <span className="qwerty-11">enter </span>
              <span className="qwerty">10 </span>
              <span className="qwerty-11">elements</span>
              {"\n"}
              <span className="qwerty">2 </span>
              {"\n"} 
              <span className="qwerty">4 </span>
              {"\n"} 
              <span className="qwerty">56 </span>
              {"\n"} 
              <span className="qwerty">8 </span>
              {"\n"}
              <span className="qwerty">7 </span>
              {"\n"} 
              <span className="qwerty">9 </span>
              {"\n"} 
              <span className="qwerty">3 </span>
              {"\n"} 
              <span className="qwerty">2 </span>
              {"\n"}
              <span className="qwerty">1 </span>
              {"\n"} 
              <span className="qwerty">5 </span>
              {"\n"} 
              <span className="qwerty-10">maximum </span>
              <span className="qwerty-3">= </span>
              <span className="qwerty">56 </span>
              {"\n"}</code>{"\n"}</pre>
        </div>
      </div>


<h2 className='headings'>Q-Write a program to input an array of 8 elements and print in reverse?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>{"            "}
          <code >{"\n"}
            <span className="qwerty-11">#include </span>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-5">iostream</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}
            <span className="qwerty">using </span>
            <span className="qwerty-5">namespace </span>
            <span className="qwerty">std</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-11">int </span>
            <span className="qwerty-10">main</span>
            <span className="qwerty-3"> ()</span>
            {"\n"}
            <span className="qwerty-3"> &#123; </span>
            {"\n"} {"\n"}
            <span className="qwerty-11"> int </span>
            <span className="qwerty">a </span>
            <span className="qwerty-3">[</span>
              <span className="qwerty">8</span>
              <span className="qwerty-3">],</span>
              <span className="qwerty-10">i</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-4"> cout </span>
            <span className="qwerty-3">&#60;&#60; "</span>
            <span className="qwerty-11">enter </span>
              <span className="qwerty">8 </span>
              <span className="qwerty-11">elements\n</span>
            <span className="qwerty-3">";</span>
            {"\n"}
            <span className="qwerty-5"> for </span>
            <span className="qwerty-3">(</span>
            <span className="qwerty-10">i </span>
            <span className="qwerty-3">= </span>
            <span className="qwerty">0</span>
            <span className="qwerty-3">; </span>
            <span className="qwerty-10">i </span>
            <span className="qwerty-3">&#60; </span>
            <span className="qwerty">8</span>
            <span className="qwerty-3">; </span>
            <span className="qwerty-10">i </span>
            <span className="qwerty-3">++) </span>
            {"\n"}
            <span className="qwerty">  cin </span>
            <span className="qwerty-3">&#62;&#62; </span>
            <span className="qwerty">a </span>
            <span className="qwerty-3">[</span>
            <span className="qwerty-10">i</span>
            <span className="qwerty-3">];</span>
            {"\n"}
            <span className="qwerty-5">  for </span>
            <span className="qwerty-3">(</span>
            <span className="qwerty-10">i </span>
            <span className="qwerty-3">= </span>
            <span className="qwerty">7</span>
            <span className="qwerty-3">; </span>
            <span className="qwerty-10">i </span>
            <span className="qwerty-3">&#62; </span>
            <span className="qwerty-3">= </span>
            <span className="qwerty">0</span>
            <span className="qwerty-3">; </span>
            <span className="qwerty-10">i </span>
            <span className="qwerty-3">--)</span>
            {"\n"}
            <span className="qwerty-4">  cout </span>
            <span className="qwerty-3">&#60;&#60; </span>
            <span className="qwerty">a </span>
            <span className="qwerty-3">[</span>
            <span className="qwerty-10">i</span>
            <span className="qwerty-3">];</span>
            {"\n"}
            <span className="qwerty-11">  return </span>
            <span className="qwerty">0 </span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-3"> &#125; </span>
            {"\n"} {"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code >
            {"\n"} 
              <span className="qwerty-11">enter </span>
              <span className="qwerty">8 </span>
              <span className="qwerty-11">elements</span>
              {"\n"}
              <span className="qwerty">4 </span>
              {"\n"} 
              <span className="qwerty">5 </span>
              {"\n"} 
              <span className="qwerty">2 </span>
              {"\n"}
              <span className="qwerty">3 </span>
              {"\n"} 
              <span className="qwerty">9 </span>
              {"\n"} 
              <span className="qwerty">4 </span>
              {"\n"} 
              <span className="qwerty">6 </span>
              {"\n"}
              <span className="qwerty">7 </span>
              {"\n"} 
              <span className="qwerty-11">76493254 </span>
              {"\n"}</code>{"\n"}</pre>
        </div>
      </div>





<h2 className='headings'>Q-Write a program to input an array of 10 elements and print in maximum in c++?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>{"            "}
          <code className="python hljs">{"\n"}
            <span className="qwerty-11">#include </span>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-5">iostream</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}
            <span className="qwerty">using </span>
            <span className="qwerty-5">namespace </span>
            <span className="qwerty">std</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-11">int </span>
            <span className="qwerty-10">main</span>
            <span className="qwerty-3"> ()</span>
            {"\n"}
            <span className="qwerty-3"> &#123; </span>
            {"\n"} {"\n"}
            <span className="qwerty-11"> int </span>
            <span className="qwerty-10">a </span>
            <span className="qwerty-3">[</span>
              <span className="qwerty">10</span>
              <span className="qwerty-3">],</span>
              <span className="qwerty-10"> i</span>
            <span className="qwerty-3">, </span>
            <span className="qwerty-5">maximum</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-4"> cout </span>
            <span className="qwerty-3">&#60;&#60; "</span>
            <span className="qwerty-2"> enter </span>
            <span className="qwerty">10</span>
              <span className="qwerty-2"> elements </span>
              <span className="qwerty-3">";</span>
            {"\n"}
            <span className="qwerty-10"> for </span>
            <span className="qwerty-3">( </span>
            <span className="qwerty-10">i </span>
              <span className="qwerty-3">= </span>
              <span className="qwerty">0</span>
              <span className="qwerty-3">; </span>
            <span className="qwerty-10">i </span>
            <span className="qwerty-5">&#60;</span>
            <span className="qwerty">10</span>
            <span className="qwerty-3">; </span>
            <span className="qwerty-10">i</span>
            <span className="qwerty-3">++)</span>
            {"\n"}
            <span className="qwerty-2"> cin </span>
            <span className="qwerty-3">&#62;&#62; </span>
            <span className="qwerty">a </span>
              <span className="qwerty-3">[</span>
              <span className="qwerty-10">i</span>
              <span className="qwerty-3">]</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-5"> maximum </span>
            <span className="qwerty-3">= </span>
            <span className="qwerty">a </span>
              <span className="qwerty-3">[</span>
              <span className="qwerty">0</span>
              <span className="qwerty-3">] </span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-10"> for </span>
            <span className="qwerty-3">( </span>
            <span className="qwerty-10">i </span>
              <span className="qwerty-3">= </span>
              <span className="qwerty">0</span>
              <span className="qwerty-3">; </span>
            <span className="qwerty-10">i </span>
            <span className="qwerty-5">&#60;</span>
            <span className="qwerty">10</span>
            <span className="qwerty-3">; </span>
            <span className="qwerty-10">i</span>
            <span className="qwerty-3">++)</span>
            {"\n"}
            <span className="qwerty-3"> &#125; </span>
            {"\n"}
            <span className="qwerty-10"> if </span>
            <span className="qwerty-3">( </span>
            <span className="qwerty">a </span>
              <span className="qwerty-3">[</span>
              <span className="qwerty-10">i</span>
              <span className="qwerty-3">] </span>
            <span className="qwerty-3">&#62; </span>
            <span className="qwerty-5">maximum </span>
            <span className="qwerty-3">)</span>
            {"\n"}
            <span className="qwerty-5"> maximum </span>
            <span className="qwerty-3">= </span>
            <span className="qwerty">a </span>
            <span className="qwerty-3">[</span>
            <span className="qwerty-10">i</span>
            <span className="qwerty-3">] </span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-3"> &#125; </span>
            {"\n"}
            <span className="qwerty-4">  cout </span>
            <span className="qwerty-3">&#60;&#60;</span>
            <span className="qwerty-5"> maximum </span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-11">  return </span>
            <span className="qwerty">0 </span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-3"> &#125; </span>
            {"\n"} {"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code className="python hljs">
            {"\n"} 
              <span className="qwerty-11">enter </span>
              <span className="qwerty">10 </span>
              <span className="qwerty-11">elements</span>
              {"\n"}
              <span className="qwerty">2 </span>
              {"\n"} 
              <span className="qwerty">4 </span>
              {"\n"} 
              <span className="qwerty">5 </span>
              {"\n"} 
              <span className="qwerty">3 </span>
              {"\n"}
              <span className="qwerty">1 </span>
              {"\n"} 
              <span className="qwerty">6 </span>
              {"\n"} 
              <span className="qwerty">7 </span>
              {"\n"} 
              <span className="qwerty">9 </span>
              {"\n"}
              <span className="qwerty">5 </span>
              {"\n"} 
              <span className="qwerty">6 </span>
              {"\n"} 
              <span className="qwerty-10">maximum </span>
              <span className="qwerty-3">= </span>
              <span className="qwerty">9 </span>
              {"\n"}</code>{"\n"}</pre>
        </div>
      </div>



<h2 className='headings'>Q-Write a program to add two arrays, and results should be stored into a third(3) arrays in c++?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>{"            "}
          <code >{"\n"}
            <span className="qwerty-11">#include </span>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-5">iostream</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}
            <span className="qwerty">using </span>
            <span className="qwerty-5">namespace </span>
            <span className="qwerty">std</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-11">int </span>
            <span className="qwerty-10">main</span>
            <span className="qwerty-3"> ()</span>
            {"\n"}
            <span className="qwerty-3"> &#123; </span>
            {"\n"} {"\n"}
            <span className="qwerty-11"> int </span>
            <span className="qwerty-10">a</span>
            <span className="qwerty-3">[</span>
              <span className="qwerty">5</span>
              <span className="qwerty-3">], </span>
              <span className="qwerty-10">b</span>
            <span className="qwerty-3">[</span>
              <span className="qwerty">5</span>
              <span className="qwerty-3">], </span>
              <span className="qwerty-10">c</span>
            <span className="qwerty-3">[</span>
              <span className="qwerty">5</span>
              <span className="qwerty-3">], </span>
              <span className="qwerty-10">i</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-4"> cout </span>
            <span className="qwerty-3">&#60;&#60; "</span>
            <span className="qwerty-2"> enter </span>
            <span className="qwerty">5</span>
              <span className="qwerty-2"> elements\n</span>
              <span className="qwerty-3">";</span>
            {"\n"}
            <span className="qwerty-10"> for </span>
            <span className="qwerty-3">( </span>
            <span className="qwerty-10">i </span>
              <span className="qwerty-3">= </span>
              <span className="qwerty">0</span>
              <span className="qwerty-3">; </span>
            <span className="qwerty-10">i </span>
            <span className="qwerty-5">&#60;</span>
            <span className="qwerty">5</span>
            <span className="qwerty-3">; </span>
            <span className="qwerty-10">i</span>
            <span className="qwerty-3">++)</span>
            {"\n"}
            <span className="qwerty-2"> cin </span>
            <span className="qwerty-3">&#62;&#62; </span>
            <span className="qwerty">a </span>
              <span className="qwerty-3">[</span>
              <span className="qwerty-10">i</span>
              <span className="qwerty-3">]</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-4"> cout </span>
            <span className="qwerty-3">&#60;&#60; "</span>
            <span className="qwerty-2"> enter </span>
            <span className="qwerty">5</span>
              <span className="qwerty-2"> elements\n</span>
              <span className="qwerty-3">";</span>
            {"\n"}
            <span className="qwerty-10"> for </span>
            <span className="qwerty-3">( </span>
            <span className="qwerty-10">i </span>
              <span className="qwerty-3">= </span>
              <span className="qwerty">0</span>
              <span className="qwerty-3">; </span>
            <span className="qwerty-10">i </span>
            <span className="qwerty-5">&#60;</span>
            <span className="qwerty">5</span>
            <span className="qwerty-3">; </span>
            <span className="qwerty-10">i</span>
            <span className="qwerty-3">++)</span>
            {"\n"}
            <span className="qwerty-2"> cin </span>
            <span className="qwerty-3">&#62;&#62; </span>
            <span className="qwerty">b </span>
              <span className="qwerty-3">[</span>
              <span className="qwerty-10">i</span>
              <span className="qwerty-3">]</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-4"> cout </span>
            <span className="qwerty-3">&#60;&#60; "</span>
            <span className="qwerty-2">addition both arrays\n</span>
            <span className="qwerty-3">";</span>
            {"\n"}
            <span className="qwerty-10"> for </span>
            <span className="qwerty-3">(</span>
            <span className="qwerty-10">i </span>
              <span className="qwerty-3">= </span>
              <span className="qwerty">0</span>
              <span className="qwerty-3">; </span>
            <span className="qwerty-10">i </span>
            <span className="qwerty-3">&#60; </span>
            <span className="qwerty">5</span>
            <span className="qwerty-3">; </span>
            <span className="qwerty-10">i</span>
            <span className="qwerty-3">++)</span>
            {"\n"}
            <span className="qwerty-3"> &#123; </span>
            {"\n"}
            <span className="qwerty-5"> c </span>
            <span className="qwerty-3">[</span>
            <span className="qwerty-10">i</span>
            <span className="qwerty-3">]</span>
            <span className="qwerty-3"> = </span>
            <span className="qwerty">a </span>
            <span className="qwerty-3">[</span>
            <span className="qwerty-10">i</span>
            <span className="qwerty-3">] </span>
            <span className="qwerty-3">+ </span>
            <span className="qwerty">b </span>
            <span className="qwerty-3">[</span>
            <span className="qwerty-10">i</span>
            <span className="qwerty-3">];</span>
            {"\n"}
            <span className="qwerty-4"> cout </span>
            <span className="qwerty-3">&#60;&#60;</span>
            <span className="qwerty-5"> c </span>
            <span className="qwerty-3">[</span>
            <span className="qwerty-10">i</span>
            <span className="qwerty-3">] </span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-3"> &#125; </span>
            {"\n"}
            <span className="qwerty-11">  return </span>
            <span className="qwerty">0 </span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-3"> &#125; </span>
            {"\n"} {"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code >
            {"\n"} 
              <span className="qwerty-11">enter </span>
              <span className="qwerty">5 </span>
              <span className="qwerty-11">elements</span>
              {"\n"}
              <span className="qwerty">2 </span>
              {"\n"} 
              <span className="qwerty">4 </span>
              {"\n"} 
              <span className="qwerty">6 </span>
              {"\n"} 
              <span className="qwerty">8 </span>
              {"\n"}
              <span className="qwerty">12 </span>
              {"\n"} 
              <span className="qwerty-11">enter </span>
              <span className="qwerty">5 </span>
              <span className="qwerty-11">elements</span>
              {"\n"} 
              <span className="qwerty">1 </span>
              {"\n"} 
              <span className="qwerty">3 </span>
              {"\n"}
              <span className="qwerty">5 </span>
              {"\n"} 
              <span className="qwerty">7 </span>
              {"\n"} 
              <span className="qwerty">10 </span>
              {"\n"}{"\n"}
              <span className="qwerty-10">addition both arrays </span>
              {"\n"}
              <span className="qwerty">37111524 </span>
              {"\n"}</code>{"\n"}</pre>
        </div>
      </div>

<h1 className="mt-5">  </h1>
<div className="back">
        <a href="/cpp-continue">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/cpp-function">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div></div>
    </div>
)

}
export default Carray;